import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import AuthForm, { IHandler } from '../components/AuthForm';
import Section from '../components/Section';
import PreFooter from '../components/PreFooter';
import { loginWithFacebook, loginWithGoogle, register } from '../services/auth';

const useStyles = makeStyles({
  footer: {
    bottom: 0,
    position: 'fixed',
    width: '100%',
  },
  link: {
    '&:link': {
      textDecoration: 'none',
    },
  },
});

const Register = () => {
  const { footer, link } = useStyles();
  const authRef = useRef<IHandler>(null);
  const [submitting, setSubmitting] = useState(false);
  const handleRegister = async (email: string, password: string) => {
    setSubmitting(true);
    const error = await register(email, password);
    setSubmitting(false);
    if (error) {
      authRef.current?.setError(error);
    }
  };
  const handleLoginWith = async (provider: string) => {
    let error;
    setSubmitting(true);
    switch (provider) {
      case 'facebook':
        error = await loginWithFacebook();
        break;
      case 'google':
        error = await loginWithGoogle();
        break;
      default:
        break;
    }
    setSubmitting(false);
    if (error) {
      authRef.current?.setError(error);
    }
  };

  return (
    <>
      <Container maxWidth='md'>
        <Section display='flex' flexDirection='column' alignItems='center'>
          <AuthForm
            registration
            onSubmit={handleRegister}
            onLoginWith={handleLoginWith}
            submitting={submitting}
            ref={authRef}
          />
          <Box mt={3} display='flex'>
            <Typography style={{ marginRight: 8 }}>
              มีบัญชีอยู่แล้ว ?
            </Typography>
            <Link className={link} to='/login'>
              <Typography color='secondary'>เข้าสู่ระบบที่นี่</Typography>
            </Link>
          </Box>
        </Section>
      </Container>
      <Box className={footer}>
        <PreFooter />
      </Box>
    </>
  );
};

export default Register;
